<template>
  <PbsActionButton
    v-if="props.detail"
    :label="$t('general.moreActions')"
    :items="actionButtonItems"
    :mod-vertical="modVertical"
    :mod-large="modLarge"
  />
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PbsActionButton, { PbsActionButtonItem } from '@/components/PbsActionButton.vue';
import { useModalStore } from '@/modules/core/store/modal.store';
import { ProcessTriggerDetailDto } from '@/api/backoffice/clients';
import { ENUM_TriggerTypes } from '@/modules/configuration/common/configuration-enumerations.common';
import { ProcessTriggerActionButtonType } from '@/modules/configuration/common/process-trigger.common';
import { useProcessTriggerDetailStore } from '@/modules/configuration/store/process-trigger/process-trigger-detail.store';

const store = useProcessTriggerDetailStore();
const modalStore = useModalStore();

const { t } = useI18n();

type ProcessTriggerActionButtonProps = {
  detail: ProcessTriggerDetailDto;
  modVertical?: boolean;
  modLarge?: boolean;
  actions: ProcessTriggerActionButtonType[];
};

const props = withDefaults(defineProps<ProcessTriggerActionButtonProps>(), {
  modVertical: false,
  modLarge: false,
  detail: null,
  actions: () => []
});

const actionButtonItems = computed((): PbsActionButtonItem[] => {
  const items = createActionButtonItems();
  return props.actions?.map((action) => items.find((x) => x.name === action)).filter((x) => !!x) ?? [];
});

const createActionButtonItems = () => {  
  const isExecutable = props.detail?.triggerType?.id === ENUM_TriggerTypes.TijdTrigger.id;

  return [
    {
      name: ProcessTriggerActionButtonType.Execute,
      label: t('processtrigger.actions.execute.label'),
      click: showExecuteModal,
      disabled: !isExecutable,
      ellipsis: true
    }
  ];
};

const showExecuteModal = () => {
  modalStore.showConfirmModal({
    title: t('processtrigger.actions.execute.description'),
    props: {
      confirmationMessage: t('processtrigger.actions.execute.confirmation'),
      okLabel: t('processtrigger.actions.execute.label'),
      confirm: () => store.execute(props.detail.id)
    }
  });
};
</script>

<style lang="scss" scoped></style>
